import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import AlertErrorForm from "../component/AlertErrorForm";
import {
    CONTRACT_PARAM_FORMATS,
    CONTRACT_SYSTEM_PARAMS,
    buildTemplateParams,
    isCustomTemplateParam,
    normalizeParamTitle,
    parseContractParams,
    toFormattedPlaceholder,
} from "./contractParams";
import PreviewFile from "./PreviewFile";

const normalizeFileList = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [value];
        } catch (error) {
            return [value];
        }
    }
    return [value];
};

export default function FormLoaiHopDong() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [customParams, setCustomParams] = useState([]);
    const [paramTitle, setParamTitle] = useState('');
    const [paramLabel, setParamLabel] = useState('');
    const [copiedParam, setCopiedParam] = useState('');
    const [paramFilter, setParamFilter] = useState('');
    const [openParamMenu, setOpenParamMenu] = useState('');

    const defaultdetail = {
        title: '',
        filetype: 'docx',
        urlfile: [],
        params: '',
        author_code: user.data.code,
        status: 1,
    };

    useEffect(function () {
        if (id > 0) {
            Axios.get(URL_LIST_ALL + "hopdong_type/" + id, user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        let data_rs = res.data.data
                        data_rs.urlfile = normalizeFileList(data_rs.urlfile)
                        setDetail(data_rs);
                        setCustomParams(parseContractParams(res.data.data.params).filter(isCustomTemplateParam));
                    } else console.log(res.data.message);
                }).catch((err) => console.log(err));
        }
    }, [user, id]);

    const saveSuccess = (message, resetForm) => {
        resetForm();
        confirmAlert({
            title: 'Thành công',
            message,
            buttons: [{
                label: 'OK', onClick: () => {
                    window.location.href = "/mau-hop-dong";
                },
            }],
        });
    };

    const saveError = (message) => {
        confirmAlert({
            title: 'Lỗi',
            message,
            buttons: [{ label: 'OK' }],
        });
    };

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tiêu đề').max(200, "Độ dài không quá 200 ký tự"),
            urlfile: Yup.mixed().test('required-file', 'Vui lòng upload file hợp đồng', (value) => {
                if (Array.isArray(value)) return value.length > 0;
                return !!value;
            }),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            values.status = 0;
            setLoading(true);
            const templateParams = buildTemplateParams(customParams);
            let postData = [];
            values.params = JSON.stringify(templateParams);
            values.urlfile = normalizeFileList(values.urlfile);
            postData = values;


            const request = id > 0
                ? (values.file
                    ? Axios.post(URL_LIST_ALL + 'hopdong_type/', postData, user.config)
                    : Axios.put(URL_LIST_ALL + 'hopdong_type/' + id, postData, user.config))
                : Axios.post(URL_LIST_ALL + 'hopdong_type', postData, user.config);

            request.then(res => {
                setLoading(false);
                setSubmitting(false);
                setRefresh(!refresh);
                if (res.data.status === "success") {
                    saveSuccess(id > 0 ? 'Bạn cập nhật mẫu hợp đồng thành công' : 'Bạn thêm mới mẫu hợp đồng thành công', resetForm);
                } else {
                    saveError(res.data.message);
                }
            }).catch(err => {
                setLoading(false);
                setSubmitting(false);
                console.log(err);
            });
        },
    });

    const addCustomParam = () => {
        const title = normalizeParamTitle(paramTitle);
        if (title !== '') {
            let newList = customParams.slice();
            if (!newList.find((item) => item.title === title)) {
                newList.push({ title: title, value: '', label: paramLabel || title, custom: true });
            }
            setCustomParams(newList);
            setParamTitle('');
            setParamLabel('');
        }
    };

    const deleteCustomParam = (key) => {
        let newList = customParams.slice();
        newList.splice(key, 1);
        setCustomParams(newList);
    };

    const editCustomParam = (i, type, value) => {
        let cloneParams = customParams.slice();
        cloneParams[i][type] = type === 'title' ? normalizeParamTitle(value) : value;
        setCustomParams(cloneParams);
    };

    const copyParam = (title, format = '') => {
        const text = toFormattedPlaceholder(title, format);
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setCopiedParam(text);
                    setOpenParamMenu('');
                })
                .catch(() => setCopiedParam(''));
        }
    };

    const renderParamCopyMenu = (title, prefix = 'param') => {
        const menuKey = prefix + '-' + normalizeParamTitle(title);
        const isOpen = openParamMenu === menuKey;
        return (
            <div className="position-relative">
                <button
                    type="button"
                    className="btn btn-sm p-0 text-muted"
                    style={{fontSize:17}}
                    onClick={() => setOpenParamMenu(isOpen ? '' : menuKey)}
                    title="Tùy chọn copy"
                >
                    <span className="far fa-caret-square-down"></span>
                </button>
                {isOpen &&
                    <div className="position-absolute bg-white border rounded shadow-sm p-1" style={{ top: '100%', right: 0, zIndex: 20, minWidth: 170 }}>
                        {CONTRACT_PARAM_FORMATS.filter((format) => format.value !== '').map((format) => {
                            const placeholder = toFormattedPlaceholder(title, format.value);
                            return (
                                <button
                                    key={format.value}
                                    type="button"
                                    className="dropdown-item small"
                                    onClick={() => copyParam(title, format.value)}
                                >
                                    <span>{format.label}</span>
                                    <br />
                                    <code>{placeholder}</code>
                                </button>
                            );
                        })}
                    </div>
                }
            </div>
        );
    };

    const filteredSystemParams = CONTRACT_SYSTEM_PARAMS.filter((item) => {
        const keyword = paramFilter.trim().toLowerCase();
        if (!keyword) return true;
        return item.title.toLowerCase().includes(keyword)
            || item.label.toLowerCase().includes(keyword);
    });

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/mau-hop-dong">Danh sách mẫu Văn bản, Hợp đồng</Link>
                    </li>
                    <li>{id ? 'Cập nhật mẫu Văn bản, Hợp đồng' : 'Thêm mới mẫu Văn bản, Hợp đồng'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Mẫu Văn bản, Hợp đồng</h3>
                        </div>
                    </div>

                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-sm-4 col-12 form-group">
                                <label>Tên mẫu <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Loại file Văn bản, Hợp đồng <span className="text-danger">*</span></label>
                                <select className="form-select height32" {...formik.getFieldProps("filetype")} >
                                    <option value="">Chọn loại file Văn bản, Hợp đồng</option>
                                    <option value="docx">Văn bản Word (.docx)</option>
                                    <option value="doc">Văn bản Word (.doc)</option>
                                </select>
                                <AlertErrorForm formik={formik} name="filetype"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>

                            <div className="col-lg-8 col-12 form-group">
                                <div className="w-100">
                                    <label>File Hợp đồng <span className="text-danger">*</span></label>
                                    <PreviewFile
                                        itemClass="col-12 col-sm-3 mb-3"
                                        detail={{ list_file: normalizeFileList(formik.values.urlfile) }}
                                        onSelect={(newFiles) => {
                                            const updatedFiles = [...normalizeFileList(formik.values.urlfile), ...normalizeFileList(newFiles)];
                                            formik.setFieldValue("urlfile", updatedFiles);
                                            formik.setFieldTouched("urlfile", true);
                                        }}
                                        onRemove={(indexToRemove) => {
                                            const updatedFiles = normalizeFileList(formik.values.urlfile).filter((_, i) => i !== indexToRemove);
                                            formik.setFieldValue("urlfile", updatedFiles);
                                            formik.setFieldTouched("urlfile", true);
                                        }}
                                        // 4. Cho phép sửa (hiện nút xóa và nút thêm)
                                        isEdit={true}
                                    />
                                    <AlertErrorForm formik={formik} name="urlfile"></AlertErrorForm>
                                </div>
                            </div>
                            <div className="col-12"></div>

                            <div className="col-sm-12 col-12 form-group">
                                <div className="d-flex flex-wrap align-items-center justify-content-between mb-2">
                                    <label className="mb-1">Tham số hệ thống</label>
                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
                                        <small className="text-muted me-2">{filteredSystemParams.length}/{CONTRACT_SYSTEM_PARAMS.length}</small>
                                        <input
                                            type="text"
                                            className="form-control height32"
                                            style={{ width: 240 }}
                                            placeholder="Tìm tham số"
                                            value={paramFilter}
                                            onChange={(e) => setParamFilter(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {filteredSystemParams.map((item) => {
                                        const placeholder = toFormattedPlaceholder(item.title);
                                        const isCopied = copiedParam === placeholder
                                            || CONTRACT_PARAM_FORMATS.some((format) => copiedParam === toFormattedPlaceholder(item.title, format.value));
                                        return <div className="col-6 col-sm-3 mb-2" key={item.title}>
                                            <div className={'border rounded p-2 h-100 position-relative ' + (isCopied ? 'border-success bg-light' : 'border-secondary')}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm text-start w-100 p-0 pe-4"
                                                    title={item.label}
                                                    onClick={() => copyParam(item.title)}
                                                >
                                                    <span>{item.label}: </span>
                                                    <code>{placeholder}</code>
                                                    {isCopied && <span className="ms-2 text-success">Đã copy</span>}
                                                </button>
                                                <div className="position-absolute" style={{ top: 6, right: 6 }}>
                                                    {renderParamCopyMenu(item.title, 'system')}
                                                </div>
                                            </div>
                                        </div>;
                                    })}
                                    {filteredSystemParams.length === 0 && <span className="text-muted">Không tìm thấy tham số phù hợp</span>}
                                </div>
                            </div>

                            <div className="col-sm-12 col-12 form-group">
                                <label>Tham số tùy biến của mẫu</label>
                                <div className="row">
                                    <div className="col-4 form-group">
                                        <input type="text" placeholder="Tên tham số, ví dụ NGUOIKY" className="form-control height32" onChange={(e) => setParamTitle(e.target.value)} autoComplete="off" value={paramTitle} />
                                    </div>
                                    <div className="col-4 form-group">
                                        <input type="text" placeholder="Ghi chú hiển thị, ví dụ Người ký" className="form-control height32" onChange={(e) => setParamLabel(e.target.value)} autoComplete="off" value={paramLabel} />
                                    </div>
                                    <div className="col-4 form-group">
                                        <button type="button" className="btn btn-sm btn-info height32" onClick={() => addCustomParam()}>Thêm</button>
                                    </div>
                                </div>
                                {customParams.length > 0 &&
                                    <div className="row">
                                        {customParams.map((k, i) => {
                                            return (<div className="col-12 mb-3" key={i}>
                                                <div className="row">
                                                    <div className="col-4">
                                                        <input type='text' className="form-control height32" value={k.title || ''} onChange={(e) => editCustomParam(i, 'title', e.target.value)} />
                                                    </div>
                                                    <div className="col-4">
                                                        <input type='text' className="form-control height32" value={k.label || ''} onChange={(e) => editCustomParam(i, 'label', e.target.value)} />
                                                    </div>
                                                    <div className="col-2">
                                                        <input
                                                            type='text'
                                                            className="form-control height32"
                                                            readOnly
                                                            value={toFormattedPlaceholder(k.title || '')}
                                                            onClick={() => copyParam(k.title || '')}
                                                            title="Click để copy mặc định"
                                                        />
                                                    </div>
                                                    <div className="col-1">
                                                        {renderParamCopyMenu(k.title || '', 'custom-' + i)}
                                                    </div>
                                                    <div className="col-1">
                                                        <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteCustomParam(i)}>Xóa</button>
                                                    </div>
                                                </div>
                                            </div>);
                                        })}
                                    </div>
                                }
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </AkkhorLayout>
    );
}
